import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type {
    OrderGroupId} from "@@/shared/order-groups/order-group-id";
import {
    orderGroupIdZodSchema,
} from "@@/shared/order-groups/order-group-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import type { OrderId} from "../order-id";
import { orderIdZodSchema } from "../order-id";

const _orderStatusBaseZodSchema = z.object({
    _id: orderIdZodSchema,
    _type: z.literal("ORDER_STATE"),
    _createdAt: isoAndUnixZodSchema,
    orderGroupId: orderGroupIdZodSchema,
    orderId: orderIdZodSchema,
});
type _OrderStatusBase = z.infer<typeof _orderStatusBaseZodSchema>;

const _orderStatusBaseFactory = (
    orderId: OrderId,
    orderGroupId: OrderGroupId,
): _OrderStatusBase => ({
    _id: generateId({ prefix: "order_state__" }),
    _createdAt: nowIsoAndUnix(),
    _type: "ORDER_STATE",
    orderGroupId,
    orderId,
});

export { _orderStatusBaseFactory, _orderStatusBaseZodSchema };
export type { _OrderStatusBase };
